<template>
    <div class="overall-bg">
        <b-container fluid="xl">
            <b-row class="pt-3">
                <b-col>
                    <BacktoPage :backlist="true" :goback="router.back" :flag="5" />
                    <!-- <Headerlayout :headertext="t('assetManagement.AssetItemDetails.tableheading')"
                        :contenttext="t('assetManagement.AssetItemDetails.tableHeaderContent')">
                    </Headerlayout> -->
                </b-col>
            </b-row>

            <b-row class="py-3">
                <b-col lg="5" xl="5" xxl="4" md="5" sm="5">
                    <div class="assetcard">
                        <Card class="summarycard">
                            <template #content>
                                <b-row>
                                    <b-col>
                                        <h6 class="mx-3 my-2 ">Item Information</h6>
                                        <b-row class="px-3">
                                            <b-col sm="12" md="6" lg="6" xl="6">
                                                <b-row>
                                                    <b-col lg="5" md="5" sm="5" cols="5" class="form-field-column">
                                                        <p class="light-txt">Code:
                                                        </p>
                                                    </b-col>
                                                    <b-col lg="7" md="7" sm="7" cols="7"
                                                        class="form-field-column text-start">
                                                        <p class="fn14">{{ isFetchData.Code }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col sm="12" md="6" lg="6" xl="6">
                                                <b-row>
                                                    <b-col lg="5" md="5" sm="5" cols="5" class="form-field-column">
                                                        <p class="light-txt">Name:
                                                        </p>
                                                    </b-col>
                                                    <b-col lg="7" md="7" sm="7" cols="7"
                                                        class="form-field-column text-start">
                                                        <p class="fn14">{{ isFetchData.Name }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                        <b-row class="px-3">
                                            <b-col sm="12" md="6" lg="6" xl="6">
                                                <b-row>
                                                    <b-col lg="5" md="5" sm="5" cols="5" class="form-field-column">
                                                        <p class="light-txt">Group:
                                                        </p>
                                                    </b-col>
                                                    <b-col lg="7" md="7" sm="7" cols="7"
                                                        class="form-field-column text-start">
                                                        <p class="fn14">{{ isFetchData.ItemGroupName }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col sm="12" md="6" lg="6" xl="6">
                                                <b-row>
                                                    <b-col lg="5" md="5" sm="5" cols="5" class="form-field-column">
                                                        <p class="light-txt">Category:
                                                        </p>
                                                    </b-col>
                                                    <b-col lg="7" md="7" sm="7" cols="7"
                                                        class="form-field-column text-start">
                                                        <p class="fn14">{{ isFetchData.ItemCategoryName }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                        <!-- <div class="d-flex">
                                        <p class="me-3">Code:</p>
                                        <p>
                                            {{ isFetchData.Name }}
                                        </p>
                                    </div>
                                    <div class="d-flex my-2">
                                        <p class="me-3">Name:</p>
                                        <p>
                                            {{ isFetchData.Name }}
                                        </p>
                                    </div>
                                    <div class="d-flex my-2">
                                        <p class="me-3">Group:</p>
                                        <p>
                                            {{ isFetchData.Name }}
                                        </p>
                                    </div>
                                    <div class="d-flex my-2">
                                        <p class="me-3">Category:</p>
                                        <p>
                                            {{ isFetchData.Name }}
                                        </p>
                                    </div> -->

                                    </b-col>
                                    <!-- <b-col>
                      <h6>DELIVERY TERMS</h6>
                      <p>{{ details.DeliveryTerms }}</p>
                    </b-col> -->
                                </b-row>

                            </template>
                        </Card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="overall-bg p-0 header-top">
            <section>
                <b-container class="storetabdetails">

                    <TabView class="tabview-custom issue-tabs" v-model:activeIndex="clases" ref="tabview4"
                        :scrollable="true" @keyup.enter="handleKeyDown">
                        <!-- <TabPanel v-for="(tab, index) in TabArray" :key="index">
                            <template #header>
                                <div class="d-flex align-items-center settabheight" @click="TabClick(tab, index)">
                                    <img :src="tab.Image" class="DetailsIcon" />
                                    <span style="padding: 0px 7px">{{ $t(`${tab["Path"]}`) }}</span>
                                </div>
                            </template>
<div v-if="activeTabIndex === index">
    <component :is="tab.FixedHref" :propsParams="paramValues" :FunctionRights="functionRights" :Addstatus="false"
        :tstatus="false" @StoreCode="storeCode" />
</div>


</TabPanel> -->
                        <TabPanel>
                            <template #header>
                                <div class="d-flex align-items-center settabheight">
                                    <!-- <img :src="tab.Image" class="DetailsIcon" /> -->
                                    <span style="padding: 0px 7px">Asset</span>
                                </div>
                            </template>
                            <div>
                                <SkeletonTableLoader v-if="loading" :loading="loading" />
                                <AssetTableView v-else />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <template #header>
                                <div class="d-flex align-items-center settabheight">
                                    <!-- <img :src="tab.Image" class="DetailsIcon" /> -->
                                    <span style="padding: 0px 7px">Agreement</span>
                                </div>
                            </template>
                            <div>
                                <AssetAgreementTableView />

                            </div>
                        </TabPanel>

                        <TabPanel>
                            <template #header>
                                <div class="d-flex align-items-center settabheight">
                                    <!-- <img :src="tab.Image" class="DetailsIcon" /> -->
                                    <span style="padding: 0px 7px">Sub Asset</span>
                                </div>
                            </template>
                            <div>
                                <SubAssetTableView />
                            </div>
                        </TabPanel>
                    </TabView>
                </b-container>
            </section>
        </div>
    </div>

</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    computed,
    reactive,
    onMounted,
    watch,
    onUnmounted,
} from "vue";

import { useRoute, useRouter } from "vue-router";

import InBoundIssueTableView from "../../../../../../../modules/Inventory/pages/Transaction/stockin/issue/InBoundIssue/InBoundIssueTableView.vue";
import OutBoundIssueTableView from "../../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/OutBoundIssue/OutBoundIssueTableView.vue";
import MastersService from "../../../../../../../modules/Inventory/Service/MastersService";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { useI18n } from 'vue-i18n';
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import AssetTableView from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/AssetDetails/AssetTableView.vue"

import SubAssetTableView from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/AssetDetails/SubAssetTableView.vue"

import FormSkeleton from "../../../../../../../components/SkeletonLoaderComponents/FormSkeleton.vue";

import AssetAgreementTableView from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/AssetDetails/AssetAgreementTableView.vue"
import { useCommonStore } from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/store/CommonStore";
import ItemMasService from "../../../../../../../modules/Inventory/Service/ItemMasService";




export default defineComponent({
    components: {
        OutBoundIssueTableView,
        InBoundIssueTableView,
        AssetAgreementTableView,
        BacktoPage,
        Headerlayout,
        AssetTableView,
        SubAssetTableView,
        FormSkeleton
    },

    props: {},

    setup(props, { emit }) {
        //get local storage session data
        const commonStore = useCommonStore()

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        let HospitalId = Number(usersData.OrganizationId);

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("EntityData");
        let EntityData;
        if (SessionEntityData !== null) {
            EntityData = JSON.parse(SessionEntityData);
        }
        //

        const route = useRoute();
        const router = useRouter();
        const { t } = useI18n();

        const data = route.query.data as string;
        const queryform = JSON.parse(data);
        let menuarray: any = ref([]);
        let TabArray: any = ref([]);
        const activeTabIndex = ref(0);
        const clases = ref(0);

        let Rights = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
        });

        let functionRights = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
            CreateId: 0,
            UpdateId: 0,
            ReadId: 0,
            DeleteId: 0,
            EntityId: 0,
        });

        const paramValues = ref({
            Id: "",
            Type: "",
            status: 0,
            storename: "",
        });

        let StoreCode = ref();

        const storeCode = (data) => {
            StoreCode.value = data;
        };

        watch(
            () => route.query.Id,
            (newVal: any) => {
                debugger;
                paramValues.value.Id = newVal;
                paramValues.value.Type = route.query.Type as string;
                paramValues.value.status = Number(route.query.status);
                paramValues.value.storename = route.query.storename as string;

                clases.value = 0;
                LoadMenus();
            }
        );

        // onMounted(() => {
        //     paramValues.value.Id = String(route.query.Id);
        //     paramValues.value.Type = route.query.Type as string;
        //     paramValues.value.status = Number(route.query.status);
        //     paramValues.value.storename = route.query.storename as string;

        //     LoadMenus();
        // });

        async function LoadMenus() {
            debugger;
            let response = await MastersService.GetMenus(
                6,
                rolesData.RoleId,
                usersData.OrganizationId
            );

            console.log("MenuListStoreTabDetails", response["result"]);
            menuarray.value = response["result"];

            BindTabsByStore(menuarray.value);
        }

        function BindTabsByStore(MenuArray) {
            debugger;
            TabArray.value = MenuArray.filter((item) =>
                item.StoreRights.split(",").includes(route.query.status)
            );

            console.log(route.query.status);
            console.log(TabArray.value);

            if (TabArray.value.length > 0) {
                TabClick(TabArray.value[0], 0);
            }
        }

        async function TabClick(SubMenuDetails, index) {
            debugger;
            activeTabIndex.value = index;
            clases.value = index;

            console.log("SubMenuEntityId", SubMenuDetails.EntityId);

            let InstantEntityId = {
                EntityId: SubMenuDetails.EntityId,
            };
            localStorage.removeItem("EntityData");
            localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

            const response = await MastersService.CheckMenuRights(
                InstantEntityId.EntityId,
                rolesData.RoleId
            );
            console.log(response["result"]);

            for (let i = 0; i < response["result"].length; i++) {
                const operation = response["result"][i];
                if (operation.OperationName === "Create") {
                    functionRights.value.CreateId = operation.OperationID;
                    Rights.value.Create = operation.IsActive;
                } else if (operation.OperationName === "Update") {
                    functionRights.value.UpdateId = operation.OperationID;
                    Rights.value.Update = operation.IsActive;
                } else if (operation.OperationName === "Read") {
                    functionRights.value.ReadId = operation.OperationID;
                    Rights.value.Read = operation.IsActive;
                } else if (operation.OperationName === "Delete") {
                    functionRights.value.DeleteId = operation.OperationID;
                    Rights.value.Delete = operation.IsActive;
                }
            }
            functionRights.value.EntityId = InstantEntityId.EntityId;
            functionRights.value.Create = Rights.value.Create;
            functionRights.value.Update = Rights.value.Update;
            functionRights.value.Read = Rights.value.Read;
            functionRights.value.Delete = Rights.value.Delete;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            debugger;
            if (event.key === "ArrowLeft" && clases.value > 0) {
                clases.value--; // Move to the previous tab on left arrow press
            } else if (
                event.key === "ArrowRight" &&
                clases.value < TabArray.length - 1
            ) {
                clases.value++; // Move to the next tab on right arrow press
            }
            activeTabIndex.value = clases.value;
        };
        const loading = ref(false);
        const isFetchData = ref({
            Id: 0,
            Name: "",
            Code: "",
            ItemCategoryName: "",
            ItemGroupName: "",
            SupplierName: "",
            InvoiceDate: "",
            InvoiceNo: "",
            DocNo: "",
            StockInHand: 0
        });
        async function itemDataFetch() {
            debugger;
            try {
                try {
                    loading.value = true;

                    // alert(JSON.stringify(data1[0]))
                    const response = await ItemMasService.Edit(
                        queryform.Id,
                        HospitalId

                    );
                    const data2 = response["result"];


                    Object.keys(isFetchData.value).forEach((key) => {
                        if (data2[key]) isFetchData.value[key] = data2[key];
                    });

                    loading.value = false;
                } catch (error) {
                    loading.value = false;
                    alert(error);
                }
            } catch (error) {
                console.error(error);
            }
        }

        onMounted(async () => {
            try {
                await commonStore.LoadlistAssetByItemId(queryform.Id, 0, HospitalId, queryform.BranchId, queryform.StoreId, 0);
                await itemDataFetch()
            } catch (error) {
                console.error('Error in onMounted:', error);
            } finally {
            }
        });
        return {
            isFetchData,
            t,
            router,
            menuarray,
            TabClick,
            functionRights,
            TabArray,
            activeTabIndex,
            handleKeyDown,
            clases,
            storeCode,
            paramValues,
            HospitalId,
            loading
        };
    },
});
</script>
<style lang="scss">
.p-tabview .issue-tabs .p-tabview-panels {
    margin-top: 0 !important;
}

.assetcard .p-card .p-card-content {
    /* padding: 1.25rem 0; */
    padding: 0px !important;
}

.assetcard .p-card .p-card-body {
    padding: 6px !important;
}

//.summarycard .p-card .p-card-content {
//    padding: 0px !important;
//}</style>
